import AccessActionsContainer from '../atoms/container/accessActionsContainer';
import AccessBackground from '../atoms/container/accessBackground';
import AccessButtonContainer from '../atoms/container/accessButtonContainer';
import AccessLogo from '../atoms/images/accessLogo';
import AccessTextBlockContainer from '../atoms/container/accessTextBlockContainer';
import AccessTextDescription from '../atoms/text/accessTextDescription';
import AccessTextId from '@components/atoms/text/accessTextId';
import AccessTextTitle from '../atoms/text/accessTextTitle';
import ConfirmButton from '../atoms/buttons/confirmButton';
import Languages from '../../../shared/types/enums/languages';
import LanguageContext from '../../../shared/components/utils/context/languageContext';
import LanguagesList from '../sections/list/languagesList/languagesList';
import QRCode from '../sections/qr/qrCode';
import TranslationManager from '../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../shared/components/utils/hooks/useKeyboard';
import { magicRemoteSelector } from '../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../shared/store/hooks';

function TAccess({
  buttonText,
  description,
  idDevice,
  languages,
  title,
  qrUrl,
  action,
  returnAction,
}: {
  buttonText: string | null;
  description: string;
  idDevice?: string;
  languages?: Languages[];
  title: string;
  qrUrl?: string;
  action: () => void;
  returnAction?: () => void;
}) {
  const { enabled } = useAppSelector(magicRemoteSelector);

  const setLanguage = (language?: Languages) => {
    language && TranslationManager.setLanguage(language);
  };

  useKeyboard({
    canBeFocused: false,
    stopPropagation: true,
    keyDownHandler: (key) => {
      if (key === 'SELECT') {
        action();
      } else if (key === 'BACK' && returnAction) {
        returnAction();
      }
    },
  });

  return (
    <AccessBackground>
      <AccessTextBlockContainer>
        <AccessTextTitle>{title}</AccessTextTitle>
        <AccessTextDescription
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {qrUrl ? <QRCode url={qrUrl} /> : null}
        {idDevice ? <AccessTextId>{`ID: ${idDevice}`}</AccessTextId> : null}
      </AccessTextBlockContainer>
      <AccessActionsContainer>
        {buttonText ? (
          <AccessButtonContainer>
            <ConfirmButton
              focused={!enabled}
              width={480}
              height={75}
              onClick={action}
            >
              {buttonText}
            </ConfirmButton>
          </AccessButtonContainer>
        ) : null}
      </AccessActionsContainer>
      <AccessLogo key={'logo'} />
      {languages ? (
        <LanguageContext.Provider value={{ setLanguage }}>
          <LanguagesList languages={languages} />
        </LanguageContext.Provider>
      ) : null}
    </AccessBackground>
  );
}

export default TAccess;
